import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import nestApiService from 'services/api/nest-api-service'

export interface CreditCardsState {
  isLoading: boolean
  creditCards: CreditCard[]
}

const initialState: CreditCardsState = {
  isLoading: false,
  creditCards: []
}

export const creditCardsSlice = createSlice({
  name: 'credit-cards',
  initialState,
  reducers: {
    resetCreditCardsState: (state) => {
      state = initialState
      return state
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getCreditCards.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getCreditCards.fulfilled, (state, action) => {
        state.isLoading = false
        state.creditCards = action.payload
      })
      .addCase(getCreditCards.rejected, (state) => {
        state.isLoading = false
        state.creditCards = []
      })
})

export const { resetCreditCardsState } = creditCardsSlice.actions

export default creditCardsSlice.reducer

interface GetCreditCardsParams {
  patientId: number
}

export const getCreditCards = createAsyncThunk(
  'get-credit-cards',
  async ({ patientId }: GetCreditCardsParams, { rejectWithValue }) => {
    try {
      const { data } = await nestApiService.apiInstance.get<CreditCard[]>(`/spree-credit-card?patientId=${patientId}`)

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

interface AddCreditCardParams {
  patientId: number
  creditCardData: {
    name: string
    number: string
    expiry: string
    installments: number
    iuguCardId: string
  }
}

export const addCreditCard = createAsyncThunk(
  'add-credit-card',
  async (params: AddCreditCardParams, { rejectWithValue }) => {
    try {
      const { data } = await nestApiService.apiInstance.post<CreditCard>('/spree-credit-card', params)

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export interface CreditCard {
  id: number
  month: string
  year: string
  ccType: null
  lastDigits: string
  addressId: null
  gatewayCustomerProfileId: string
  gatewayPaymentProfileId: null
  createdAt: string
  updatedAt: string
  name: string
  userId: number
  paymentMethodId: number
  default: boolean
  deletedAt: null
  cardId: null
  iuguCardId: string
  iuguCustomerId: string
}
